import { isWeb } from '@volt-libs/foundation'
import config from './internalProd'

const conf = {
    ...config,
    urls: {
        ...config.urls,
        authUrl: 'https://edsmobileprod.ott.ooredoo.qa:33428',
        apigeeUrl: 'https://uat-02.apigw.test.apigee.ooredoo.qa',
        soloAuthUrl: 'https://sit-01.apigw.test.apigee.ooredoo.qa',
        emi: {
            baseUrl: 'https://waf-ooredoo-api.ifs.vubiquity.com/emi',
            homePath: `3.0/{population}/${isWeb ? 1 : 3}`,
            defaultPopulation: 'prod',
        },
    },
    authenticationType: 'iptv',
    authenticationTypeTv: ['iptv'],
    ooredoo: {
        clientId: 'KIbxyh8sTA',
        userAgent: 'OoredooApigw',
        clientKey: 'pJNAdQ0nWVoHeAdnlTjG9jS8Trg3yQjbJ7iImnaKJaqUvx87',
        clientSecret: 'Q106hE3iwWqPIGFNbn3rVlHPGAQl7z7SiUN3ebtsylYax9JnrrI6B6Shz3OuLEYl',
        lmsEnvironment: 'OQ_NG_RES',
        soloToken: "IElZR2JzU01IOUk0aUNrRTdaWkdaN3RueEpDZEZDdTNWY2RxQmR5RWdUVkRHdXhwNzpBRE5LQ05BWUNhSTMxY1R4R3RTbnIzOW5BSFBVNmk4UE9BaDZQVGRGRjFDdTkzaVdnczM4MGlKMkdZYk9JQTNu",
        phoneNumberVisibleDigits: 4, // to get obfuscated phone numbers
        // For debug purposes (TODO: to be removed later)
        // To be removed for official delivery
        // forceIptvAccountNumber: '2110060837641',
        // debugValidateOTP: '0000',
    },
    agama: {
        // Agama analytics status
        enable: true,
        //Console URI
        _configuration:
            'emp_service=https://aggregation.castling.uk/report;report_interval=240;id_report_interval=4800;operator_id=Ooredoo_0x5E01_VLTN;',
        // player name
        playerName: 'Shaka Player',
        playerVersion: '4.3.8-nmp-2',
        caSystem: 'PlayReady',
        cdn: 'Huawei',
        //DEBUG for development and INFO for Prod.
        verbose: 'Agama.LogLevel.FATAL',
    },
    firebaseConfig: {
        enabled: true,
        apiKey: `${isWeb ? 'AIzaSyBSKAa8fBeUGPn2A9MEGrRGJjfsxs2w5O0' : 'AIzaSyCqUA4E7OIEn8811bZWggQLPO8_zX73FGg'}`,
        authDomain: "ooredoo---staging.firebaseapp.com",
        projectId: "ooredoo---staging",
        storageBucket: "ooredoo---staging.firebasestorage.app",
        messagingSenderId: "150583400154",
        appId: `${isWeb ? '1:150583400154:web:a2f1e8b0667891bb54b7e3' : '1:150583400154:web:276573c8aebbe2f054b7e3'}`,
        measurementId: `${isWeb ? 'G-Z2BHT02CBH' : 'G-J1CS8HNMFK'}`
    },
    env: 'qa',
    hybridHeight: isWeb ? '135px' : '250px',
    watermark: {
        enabled: true,
        strength: 70
    }
}

export default conf
